import MentalHealthTest from "./MentalHealthTest"

export default MentalHealthTest
